import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { GrClose } from "react-icons/gr";
import { primaryColor, surfaceColor, surfaceColor1, surfaceColor2 } from "../constants/colors";
import { fetchDoctorCategories } from "../constants/ApiConstants";
import axiosInstance from "../utils/axiosInstance";

const DoctorFilterComponent = ({ initialFilters, onFilterChanged }) => {
  const [filters, setFilters] = useState(initialFilters);
  const [categories, setCategories] = useState([]);
  const genderList = ["Male", "Female"];
  const feesTypes = [
    { title: "Fees: Low", value: 1 },
    { title: "Fees: High", value: 2 },
    { title: "Ratings", value: 3 },
  ];

  const [filterShow, setFilterShow] = useState(false);

  const onApplyFilterMobileButtonTap = () => {
    setFilterShow(!filterShow);
  };

  const onGenderItemTap = (gn) => {
    onFilterChanged({ ...filters, gender: gn });
  };

  const onSortTypeItemTap = (sortType) => {
    onFilterChanged({ ...filters, sortType: sortType });
  };

  const onCategoryChange = (e) => {
    onFilterChanged({ ...filters, category: categories.find((c) => c.id == e.target.value) });
  };

  useEffect(() => {
    axiosInstance.post(fetchDoctorCategories).then((res) => {
      setCategories(res.data.data);
    });
  }, []);

  useEffect(() => {
    setFilters(initialFilters);
  }, [initialFilters]);

  const filtersAreNotEmpty = Object.entries(filters).some(([key, value]) => value !== "");

  return (
    <Wrapper filterShow={filterShow}>
      <button type="button" className="mobile__filter_row" onClick={onApplyFilterMobileButtonTap}>
        <strong>APPLY FILTER</strong>
      </button>
      <div className="filter_modal">
        <h5>Apply Search Filters {filterShow && <GrClose style={{ float: "right" }} size={18} color="gray" onClick={() => setFilterShow(false)} />}</h5>
        {filtersAreNotEmpty && (
          <div className="selected__filters">
            {filters.gender && (
              <div className="selected__filter-item">
                {filters.gender}
                <GrClose onClick={() => onFilterChanged({ ...filters, gender: "" })} size={12} style={{ backgroundColor: surfaceColor2, height: 18, width: 18, padding: 3, borderRadius: 100 }} />
              </div>
            )}
            {filters.sortType && (
              <div className="selected__filter-item">
                {filters.sortType.title}
                <GrClose onClick={() => onFilterChanged({ ...filters, sortType: "" })} size={12} style={{ backgroundColor: surfaceColor2, height: 18, width: 18, padding: 3, borderRadius: 100 }} />
              </div>
            )}
            {filters.category?.title && (
              <div className="selected__filter-item">
                {filters.category.title}
                <GrClose onClick={() => onFilterChanged({ ...filters, category: "" })} size={12} style={{ backgroundColor: surfaceColor2, height: 18, width: 18, padding: 3, borderRadius: 100 }} />
              </div>
            )}
          </div>
        )}
        <span className="filter__title">Gender</span>
        <div className="gender__selection">
          {genderList.map((gItem) => (
            <div key={gItem} style={{ backgroundColor: gItem === filters.gender ? primaryColor : null, color: gItem === filters.gender ? "#fff" : null }} onClick={() => onGenderItemTap(gItem)} className="genderitem">
              {gItem}
            </div>
          ))}
        </div>
        <span className="filter__title">Category</span>
        <select className="category__selection" onChange={onCategoryChange} defaultValue={filters.category?.id}>
          <option key={"ALL"} className="c-item" value={null}>
            Select a category
          </option>
          {categories.map((category) => (
            <option key={category.id} selected={filters.category?.id === category.id} className="c-item" value={category.id}>
              {category.title}
            </option>
          ))}
        </select>

        <span className="filter__title">Sort By</span>
        <div className="fees-container">
          {feesTypes.map((ft) => (
            <div key={ft.value} style={{ backgroundColor: ft.value === filters.sortType.value ? primaryColor : null, color: ft.value === filters.sortType.value ? "#fff" : null }} onClick={() => onSortTypeItemTap(ft)} className="ft-item">
              <span>{ft.title}</span>
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .filter_modal {
    position: fixed;
    left: 0;
    right: 0;
    bottom: ${(props) => (props.filterShow ? "0" : "-999px")};
    height: max-content;
    background-color: white;
    transition: bottom 0.3s ease-in-out;
    border-right: 1px solid #eeeeee;
    z-index: 15;
    padding: 20px;
  }

  .filter__title {
    color: gray;
    font-size: 0.85rem;
    margin-top: 28px;
    margin-bottom: 12px;
    display: block;
  }

  .selected__filters {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    .selected__filter-item {
      cursor: pointer;
      padding: 2px 10px;
      background-color: ${surfaceColor1};
      border-radius: 30px;
      color: ${primaryColor};
      font-size: 0.8rem;
      display: flex;
      align-items: center;
      gap: 4px;
      transition: all ease 0.3s;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .gender__selection {
    display: flex;
    flex-wrap: wrap;
  }
  .category__selection {
    width: 100%;
    padding: 12px;
    font-size: 0.9rem;
    border-radius: 6px;
    border: 1px solid #eeeeee;
    transition: all ease-in-out 0.3s;

    &:hover {
      background-color: #eeeeee;
      cursor: pointer;
    }
  }
  .category__selection:focus {
    border: 1px solid #e3e3e3;
  }
  .genderitem,
  .c-item {
    padding: 4px 25px;
    background-color: #f1f1f1;
    margin: 0.5rem;
    border-radius: 30px;
    color: #000;
    font-weight: 500;
    font-size: 0.85rem;
    width: max-content;
    cursor: pointer;
  }
  .ft-item {
    background-color: #f1f1f1;
    margin-bottom: 16px;
    padding: 8px 18px;
    border-radius: 6px;
    color: #000;
    cursor: pointer;
  }

  .c-item,
  .ft-itemm .genderItem {
    cursor: pointer;
    transition: all cubic-bezier(0.075, 0.82, 0.165, 1) 0.3s;
    &:hover {
      color: ${primaryColor};
      opacity: 0.6;
    }
  }

  .mobile__filter_row {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 60px;
    z-index: 12;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    justify-content: center;
    align-items: center;
    outline: none;
    border: none;
    display: flex;
  }

  @media screen and (min-width: 768px) {
    .filter_modal {
      height: auto;
      position: sticky;
      width: 100%;
      left: 0;
      top: 0;
      height: 100vh;
    }

    .mobile__filter_row {
      display: none;
    }
  }
`;

export default DoctorFilterComponent;
